import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkDeleteFoldersRequest = {};
var _bulkDeleteFoldersResponse = {};
var _bulkRestoreFoldersFromTrashBinRequest = {};
var _bulkRestoreFoldersFromTrashBinResponse = {};
var _createFolderRequest = {};
var _createFolderResponse = { folder: '_folder' };
var _folder = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _generateFolderDownloadUrlRequest = {};
var _generateFolderDownloadUrlResponse = {};
var _getFolderRequest = {};
var _getFolderResponse = { folder: '_folder' };
var _listDeletedFoldersRequest = {};
var _listDeletedFoldersResponse = { folders: '_folder' };
var _listFoldersRequest = {};
var _listFoldersResponse = { folders: '_folder' };
var _searchFoldersRequest = {};
var _searchFoldersResponse = { folders: '_folder' };
var _updateFolderRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    folder: '_folder',
};
var _updateFolderResponse = { folder: '_folder' };
function resolveComWixMediaSiteMediaV1FoldersServiceUrl(opts) {
    var domainToMappings = {
        'apps._base_domain_': [
            {
                srcPath: '/_api/wix-privatemedia-proxy-server',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-privatemedia-proxy-server/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/site-media/v1',
                destPath: '/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/wix-privatemedia-proxy-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new folder in the Media Manager. <br/>
 *
 * Use the `parentFolderId` parameter to specify in which existing folder you want the new folder to be created.
 * If no folder is specified, the new folder is created in the `media-root` folder.
 */
export function createFolder(payload) {
    var _a = serializer(_createFolderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createFolderResponse, { _folder: _folder }).fromJSON;
    function __createFolder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.folder',
            method: 'POST',
            methodFqn: 'com.wix.media.site_media.v1.FoldersService.CreateFolder',
            url: resolveComWixMediaSiteMediaV1FoldersServiceUrl({
                protoPath: '/v1/folders',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createFolder.fromReq = fromReq;
    __createFolder.__isAmbassador = true;
    return __createFolder;
}
/** Gets information from a specific folder in the Media Manager. */
export function getFolder(payload) {
    var _a = serializer(_getFolderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFolderResponse, { _folder: _folder }).fromJSON;
    function __getFolder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.folder',
            method: 'GET',
            methodFqn: 'com.wix.media.site_media.v1.FoldersService.GetFolder',
            url: resolveComWixMediaSiteMediaV1FoldersServiceUrl({
                protoPath: '/v1/folders/{folderId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getFolder.fromReq = fromReq;
    __getFolder.__isAmbassador = true;
    return __getFolder;
}
/** Retrieves a list of folders in the Media Manager. To retrieve a list of folders within a specific folder in the Media Manager, pass the specific folder's ID in the `parentFolderId` parameter. If no folder is specified, the endpoint retrieves a list of folders within the root folder of the Media Manager. */
export function listFolders(payload) {
    var _a = serializer(_listFoldersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFoldersResponse, { _folder: _folder }).fromJSON;
    function __listFolders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.folder',
            method: 'GET',
            methodFqn: 'com.wix.media.site_media.v1.FoldersService.ListFolders',
            url: resolveComWixMediaSiteMediaV1FoldersServiceUrl({
                protoPath: '/v1/folders',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFolders.fromReq = fromReq;
    __listFolders.__isAmbassador = true;
    return __listFolders;
}
/**
 * Searches the Media Manager and returns a list of folders that match the terms specified in the parameters. <br/>
 *
 * If no parameters are specified, the endpoint returns all folders in the `MEDIA_ROOT` folder.
 */
export function searchFolders(payload) {
    var _a = serializer(_searchFoldersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchFoldersResponse, { _folder: _folder }).fromJSON;
    function __searchFolders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.folder',
            method: 'POST',
            methodFqn: 'com.wix.media.site_media.v1.FoldersService.SearchFolders',
            url: resolveComWixMediaSiteMediaV1FoldersServiceUrl({
                protoPath: '/v1/folders/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchFolders.fromReq = fromReq;
    __searchFolders.__isAmbassador = true;
    return __searchFolders;
}
/**
 * Updates a folder. <br />
 *
 * You can use the `parentFolderId` parameter to move a folder from its current parent folder to a different parent folder.
 */
export function updateFolder(payload) {
    var _a = serializer(_updateFolderRequest, { _folder: _folder }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateFolderResponse, { _folder: _folder }).fromJSON;
    function __updateFolder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.folder',
            method: 'PATCH',
            methodFqn: 'com.wix.media.site_media.v1.FoldersService.UpdateFolder',
            url: resolveComWixMediaSiteMediaV1FoldersServiceUrl({
                protoPath: '/v1/folders/{folder.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateFolder.fromReq = fromReq;
    __updateFolder.__isAmbassador = true;
    return __updateFolder;
}
/**
 * Generates a URL for downloading a compressed file containing a specific folder in the Media Manager. <br/>
 *
 * The compressed file can contain sub-folders, and up to 1000 files. <br/>
 */
export function generateFolderDownloadUrl(payload) {
    var _a = serializer(_generateFolderDownloadUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateFolderDownloadUrlResponse, {}).fromJSON;
    function __generateFolderDownloadUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.folder',
            method: 'POST',
            methodFqn: 'com.wix.media.site_media.v1.FoldersService.GenerateFolderDownloadUrl',
            url: resolveComWixMediaSiteMediaV1FoldersServiceUrl({
                protoPath: '/v1/folders/{folderId}/generate-download-url',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateFolderDownloadUrl.fromReq = fromReq;
    __generateFolderDownloadUrl.__isAmbassador = true;
    return __generateFolderDownloadUrl;
}
/**
 * Temporarily deletes the specified folders from the Media Manager. <br/>
 *
 * The deleted folders are moved to the Media Manager's `trash-root` folder (trash bin) unless permanently deleted. To permanently delete folders, pass the `permanent` parameter with the value `true`. Permanently deleting folders isn't reversible, so make sure that the files in these folders aren't being used in a site or in any other way as the files will no longer be accessible.
 *
 * Note the following:
 * * When a folder is deleted, the files in that folder are deleted.
 * * The specified folders can be from different parent folders.
 * * Moving multiple folders at once is an asynchronous action, and may take time for the changes to appear in the Media Manager.
 * * Attempting to delete folders that are already in the trash bin doesn't result in an error.
 * * If your site contains files from a deleted media folder, the files still appear on your site as the deleted folder is still in the Media Manager (in the trash bin).
 * * You can use the [Bulk Restore Folders From Trash Bin](https://dev.wix.com/api/rest/media/media-manager/folders/bulk-restore-folders-from-trash-bin) endpoint to restore folders from the Media Manager's trash bin.
 */
export function bulkDeleteFolders(payload) {
    var _a = serializer(_bulkDeleteFoldersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteFoldersResponse, {}).fromJSON;
    function __bulkDeleteFolders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.folder',
            method: 'POST',
            methodFqn: 'com.wix.media.site_media.v1.FoldersService.BulkDeleteFolders',
            url: resolveComWixMediaSiteMediaV1FoldersServiceUrl({
                protoPath: '/v1/bulk/folders/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteFolders.fromReq = fromReq;
    __bulkDeleteFolders.__isAmbassador = true;
    return __bulkDeleteFolders;
}
/** Restores the specified folders from the Media Manager's trash bin, and moves them to their original locations in the Media Manager. */
export function bulkRestoreFoldersFromTrashBin(payload) {
    var _a = serializer(_bulkRestoreFoldersFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkRestoreFoldersFromTrashBinResponse, {}).fromJSON;
    function __bulkRestoreFoldersFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.folder',
            method: 'POST',
            methodFqn: 'com.wix.media.site_media.v1.FoldersService.BulkRestoreFoldersFromTrashBin',
            url: resolveComWixMediaSiteMediaV1FoldersServiceUrl({
                protoPath: '/v1/bulk/trash-bin/folders/restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkRestoreFoldersFromTrashBin.fromReq = fromReq;
    __bulkRestoreFoldersFromTrashBin.__isAmbassador = true;
    return __bulkRestoreFoldersFromTrashBin;
}
/** Retrieves a list of folders in the Media Manager's trash bin. */
export function listDeletedFolders(payload) {
    var _a = serializer(_listDeletedFoldersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDeletedFoldersResponse, {
        _folder: _folder,
    }).fromJSON;
    function __listDeletedFolders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.site_media.v1.folder',
            method: 'GET',
            methodFqn: 'com.wix.media.site_media.v1.FoldersService.ListDeletedFolders',
            url: resolveComWixMediaSiteMediaV1FoldersServiceUrl({
                protoPath: '/v1/trash-bin/folders',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDeletedFolders.fromReq = fromReq;
    __listDeletedFolders.__isAmbassador = true;
    return __listDeletedFolders;
}
//# sourceMappingURL=http.impl.js.map